<template>
  <div class="product-category-swiper-wrapper">
    <el-carousel
      :interval="4000"
      type="card"
      height="680px"
      :autoplay="false"
      :loop="false"
      indicator-position="outside"
      :initial-index="1"
    >
      <el-carousel-item v-for="(item, index) in swiperData" :key="index">
        <div class="card">
          <img :src="formatWebSite(item)" alt="" />
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  props: {
    swiperData: {
      type: Array
    }
  },
  methods: {
    formatWebSite(item) {
      let webSite;
      if (this.$i18n.locale === "zh") {
        webSite = item.WebSite;
      } else if (this.$i18n.locale === "en") {
        webSite = item.EnglishWeb;
      } else if (this.$i18n.locale === "sp") {
        webSite = item.xibanyaWeb;
      }
      return webSite;
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/style/variables.less";
.product-category-swiper-wrapper {
  width: 80%;
  margin: 0 auto;

  .el-carousel__item {
    background: none;

    .card {
      width: 450px;
      height: 680px;
      background: #fff;
      margin: 0 auto;
      box-shadow: 6px 6px 12px rgba(0, 100, 178, 0.3);
      // text-align: left;
      // padding: 100px 35px 0;
      // position: relative;

      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }

  // .el-carousel__item.is-active {
  //   .card {
  //     background: @bgColor;

  //     h1 {
  //       color: #fff;
  //     }

  //     p {
  //       color: #fff;
  //     }

  //     button {
  //       display: block;
  //     }
  //   }
  // }
}
</style>
